import React, { useEffect, useRef, useState } from "react";
import Responsable from "../../../Responsable";
import styled from "styled-components";
import { media } from "../../../../constants/styles";
import { useIntersecting } from "../../../../hooks/useIntersecting";
import Text from "./Text";
import ButtonV2 from "../../../Button/ButtonV2";



const LastSection: React.FC = () => {
  const { isIntersecting } = useIntersecting();
  const [isInteracted, setIsInteracted] = useState<boolean>(false);
  const buttonRef = useRef<HTMLButtonElement>(null);


  useEffect(() => {
    if (!isInteracted && isIntersecting) setIsInteracted(true);
  }, [isIntersecting]);


  useEffect(() => {
    const button = buttonRef.current;
    const handleScroll = () => {
      if (button) {
        const rect = buttonRef.current.getBoundingClientRect();
        const absolutePosition = {
          top: rect.top + window.scrollY, // 절대 Y 좌표
          left: rect.left + window.scrollX, // 절대 X 좌표
          width: rect.width,
          height: rect.height,
        };
        // css 변수에 절대 좌표 할당
        if (absolutePosition.width && absolutePosition.height) {
          document.documentElement.style.setProperty(
            "--button-absolute-position",
            `${absolutePosition.top + absolutePosition.height}px`
          );
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.addEventListener("resize", handleScroll);
    };
  }, []);


  return (
    <Container>
      <SectionWrapper>
        <ContentWrapper>
          <Text
            smallText="You Imagine, We Create"
            bigText={
              <Responsable
                pc={
                  <>
                    혁신을 손에 잡히는 모습으로 만드는
                    <br />
                    슬로그업의 도전과 창조는 계속됩니다.
                  </>
                }
                tablet={
                  <>
                    혁신을 손에 잡히는 모습으로
                    <br />
                    만드는 슬로그업의 도전과 창조는
                    <br />
                    계속됩니다.
                  </>
                }
                mobile={
                  <>
                    혁신을 손에 잡히는
                    <br />
                    모습으로 만드는
                    <br />
                    슬로그업의 도전과 창조는
                    <br />
                    계속됩니다.
                  </>
                }
              />
            }
          />
          <ButtonV2
            ref={buttonRef}
            label="숨김버튼"
            style={{ visibility: "hidden" }}
          />
        </ContentWrapper>
      </SectionWrapper>
    </Container>
  );
};

export default LastSection;
const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 160px;
  isolation: isolate;
  width: 100%;

  padding: 160px 0px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("/image/webp/home/Section01-Bg-Pc.webp");
  ${media.TABLET} {
    padding: 140px 0px;
    background-position: center 70%;
    background-image: url("/image/webp/home/Section01-Bg-Tablet.webp");
  }
  ${media.MOBILE} {
    padding: 80px 0px;
    background-position: center 25%;
    background-image: url("/image/webp/home/Section01-Bg-Mobile.webp");
  }
`;
const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  gap: 60px;
  ${media.MOBILE} {
    gap: 40px;
  }
`;
